module.exports = __webpack_public_path__ + "static/workshop-9cbd33de5d2cad185f6d7ef88f6eebaf.png";